import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Remove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEmail2Remove"><Path d="M22 4V8.46191L12 13.501L3.5 9.21777V18.5H12V20H2V4H22Z" fill="currentColor"/><Path d="M22.7793 14.7803L20.3096 17.25L22.7793 19.7197L21.7188 20.7803L19.249 18.3105L16.7793 20.7803L15.7188 19.7197L18.1885 17.25L15.7188 14.7803L16.7793 13.7197L19.249 16.1895L21.7188 13.7197L22.7793 14.7803Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Remove;
